var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page flex-v"},[_c('HeaderNav',{attrs:{"actId":"2"}}),_c('div',{staticClass:"container flex"},[_c('Sider',{attrs:{"type":2}}),_c('div',{staticClass:"layout-right"},[_c('ScrollBar',{ref:"scrollbar",staticClass:"scrollbar"},[_c('div',{staticClass:"detail-info",domProps:{"innerHTML":_vm._s(_vm.txt)}})])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }